
import { format } from 'date-fns';
import { Building } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TableCell, TableRow } from '@/components/ui/table';
import { LeadStatusSelect } from '../LeadStatusSelect';
import { LeadRowActions } from './LeadRowActions';
import { useNavigate } from 'react-router-dom';

interface LeadRowProps {
  lead: any;
  isDeleting: string | null;
  updatingStatus: string | null;
  onDelete: (id: string) => Promise<void>;
  onStatusChange: (id: string, newStatus: string) => Promise<void>;
}

export function LeadRow({ 
  lead,
  isDeleting,
  updatingStatus,
  onDelete,
  onStatusChange
}: LeadRowProps) {
  const navigate = useNavigate();

  return (
    <TableRow>
      <TableCell className="font-medium max-w-[180px]">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-grandpal-beige rounded-full flex items-center justify-center">
            <Building className="h-4 w-4 text-grandpal-green" />
          </div>
          <div className="min-w-0 flex-1">
            <Button 
              variant="link" 
              className="p-0 h-auto font-medium text-left justify-start truncate max-w-full" 
              onClick={() => navigate(`/dashboard/leads/${lead.id}`)}
              title={lead.nursing_home_name}
            >
              <span className="truncate">{lead.nursing_home_name}</span>
            </Button>
            <span className={`block text-xs ${lead.category === 'Private' ? 'text-purple-600' : 'text-blue-600'}`}>
              {lead.category || 'Unknown'}
            </span>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <div className="max-w-[180px]">
          <p className="capitalize text-sm line-clamp-2">{lead.location}</p>
        </div>
      </TableCell>
      <TableCell>
        <LeadStatusSelect
          leadId={lead.id}
          status={lead.status || "interested"}
          updatingStatus={updatingStatus}
          onStatusChange={onStatusChange}
        />
      </TableCell>
      <TableCell>{format(new Date(lead.created_at), 'MMM d, yyyy')}</TableCell>
      <TableCell>
        <LeadRowActions 
          lead={lead}
          isDeleting={isDeleting}
          onDelete={onDelete}
        />
      </TableCell>
    </TableRow>
  );
}
